/* MG is composed from the unmodified Eduardo PNG after scenery and animation.
   No letter glyph, generated mark, or traced approximation is used here. */
(() => {
  'use strict';
  const sourceSha256='6e89421ff0aeb5c59c0a2da90e257f7c2ce5c9e7251ff16bb5dc2718e261c431';
  const rect=(x,y,w,h)=>[[x,y],[x+w,y],[x+w,y+h],[x,y+h]];
  const placements={
    // The official road paint and measured sign are baked in the approved barrio plate.
    town:[],
    artists:[
      {id:'casa-wall',quad:rect(725,35,86,65)},
      {id:'casa-rug',quad:rect(704,516,128,88)}
    ],
    trophies:[
      {id:'club-wall',quad:rect(722,48,92,69)},
      {id:'club-rug',quad:rect(710,515,116,82)},
      {id:'club-card',quad:[[289,607],[306,610],[300,617],[283,614]]}
    ],
    studio:[
      {id:'studio-wall',quad:rect(722,50,94,71)},
      {id:'studio-rug',quad:rect(700,580,136,94)},
      {id:'studio-chair',quad:rect(765,259,25,19)},
      {id:'studio-pillow',quad:[[1307,327],[1331,337],[1322,356],[1298,346]]},
      {id:'studio-case',quad:rect(81,618,25,19)}
    ],
    shop:[
      {id:'shop-wall',quad:rect(713,66,118,89)},
      {id:'shop-counter',quad:rect(741,283,59,44)},
      {id:'shop-bag',quad:[[853,216],[873,217],[873,232],[853,231]],color:'#1b1914'},
      {id:'pink-main',quad:[[219,218],[243,221],[243,239],[219,236]],color:'#bd728b'},
      {id:'pink-rack',quad:[[73,255],[95,259],[95,275],[73,271]],color:'#bd728b'},
      {id:'pink-front',quad:[[28,311],[52,314],[52,332],[28,329]],color:'#bd728b'},
      {id:'brown-main',quad:[[1109,200],[1132,205],[1132,222],[1109,217]]},
      {id:'brown-rack',quad:[[1295,267],[1319,273],[1319,291],[1295,285]]},
      {id:'black-hoodie',quad:[[1434,375],[1457,383],[1457,400],[1434,392]]},
      {id:'front-cap',quad:rect(132,347,18,14)},
      {id:'front-cap-2',quad:rect(232,370,18,14)},
      {id:'wall-cap',quad:rect(1313,37,19,14)}
    ],
    tour:[
      {id:'left-led',quad:[[128,170],[235,127],[235,213],[128,256]]},
      {id:'right-led',quad:[[1295,135],[1401,181],[1401,267],[1295,221]]},
      {id:'left-case',quad:rect(79,467,31,23)},
      {id:'right-case',quad:rect(1480,726,34,26)},
      {id:'front-case',quad:rect(253,954,34,26)}
    ]
  };
  const textures=new Map();
  function texture(logo,color){
    if(!color)return logo;
    if(textures.has(color))return textures.get(color);
    const c=document.createElement('canvas');c.width=logo.naturalWidth||logo.width;c.height=logo.naturalHeight||logo.height;
    const g=c.getContext('2d');g.drawImage(logo,0,0);g.globalCompositeOperation='source-in';g.fillStyle=color;g.fillRect(0,0,c.width,c.height);
    textures.set(color,c);return c;
  }
  function stamp(ctx,logo,q,color){
    const im=texture(logo,color),w=im.naturalWidth||im.width,h=im.naturalHeight||im.height;
    ctx.save();ctx.beginPath();ctx.moveTo(...q[0]);ctx.lineTo(...q[1]);ctx.lineTo(...q[3]);ctx.closePath();ctx.clip();
    ctx.transform((q[1][0]-q[0][0])/w,(q[1][1]-q[0][1])/w,(q[3][0]-q[0][0])/h,(q[3][1]-q[0][1])/h,q[0][0],q[0][1]);ctx.drawImage(im,0,0);ctx.restore();
    const a=(q[2][0]-q[3][0])/w,b=(q[2][1]-q[3][1])/w,c=(q[2][0]-q[1][0])/h,d=(q[2][1]-q[1][1])/h;
    ctx.save();ctx.beginPath();ctx.moveTo(...q[1]);ctx.lineTo(...q[2]);ctx.lineTo(...q[3]);ctx.closePath();ctx.clip();ctx.transform(a,b,c,d,q[1][0]-a*w,q[1][1]-b*w);ctx.drawImage(im,0,0);ctx.restore();
  }
  function draw(ctx,scene,logo){if(!logo)return;for(const p of placements[scene]||[])stamp(ctx,logo,p.quad,p.color);}
  const spriteCache=new Map();
  function spriteSheet(sheet,key,logo){
    if(!sheet||!logo)return sheet;
    if(spriteCache.has(key))return spriteCache.get(key);
    const c=document.createElement('canvas');c.width=1024;c.height=key==='npcs'?512:768;
    const g=c.getContext('2d');g.imageSmoothingEnabled=false;g.drawImage(sheet,0,0,c.width,c.height);
    if(key==='pink'||key==='brown'){
      // Bryant v7: normalized 4-direction × 3-frame sheets, feet at y224.
      const caps=[[128,59],[128,315],[128,571]];
      const chest=[[130,146],[128,402],[129,659]];
      for(let i=0;i<3;i++){
        stamp(g,logo,rect(caps[i][0]-10,caps[i][1]-7.5,20,15));
        stamp(g,logo,rect(chest[i][0]-11.5,chest[i][1]-8.5,23,17),key==='pink'?'#bc7090':null);
      }
      for(let row=0;row<3;row++){
        const y=row*256;
        stamp(g,logo,[[607,55+y],[619,53+y],[619,66+y],[607,68+y]]);
        stamp(g,logo,[[916,53+y],[927,56+y],[927,68+y],[916,65+y]]);
      }
    }
    spriteCache.set(key,c);return c;
  }
  function accessory(ctx,item,dir,scale,bob,logo){
    if(!item||item==='none')return;
    ctx.save();ctx.scale(scale,scale);ctx.translate(0,-bob/scale);ctx.lineJoin='miter';
    const side=dir==='left'?-1:1;
    if(item==='bag'){
      ctx.strokeStyle='#211913';ctx.lineWidth=7;ctx.beginPath();ctx.moveTo(-side*30,-119);ctx.lineTo(side*30,-54);ctx.stroke();
      const x=side>0?12:-48,y=dir==='up'?-95:-73;
      ctx.fillStyle='#1b1713';ctx.fillRect(x-2,y-2,40,38);ctx.fillStyle='#725139';ctx.fillRect(x,y,36,34);ctx.fillStyle='#9a7051';ctx.fillRect(x+2,y+2,32,7);ctx.fillStyle='#3e2e22';ctx.fillRect(x,y+10,36,2);
      if(logo)stamp(ctx,logo,rect(x+9,y+15,18,13));
    }else if(item==='wallet'){
      const x=side>0?34:-53,y=-48;
      ctx.fillStyle='#161613';ctx.fillRect(x-2,y-2,21,28);ctx.fillStyle='#50402f';ctx.fillRect(x,y,17,24);ctx.fillStyle='#8a7153';ctx.fillRect(x+2,y+2,13,2);
      if(logo)stamp(ctx,logo,rect(x+3,y+8,11,8));
    }
    ctx.restore();
  }
  window.MGBrand=Object.freeze({draw,spriteSheet,accessory,sourceSha256,placements:Object.freeze(placements)});
})();
